// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2WN17","gfeWrapper":"CalendarEvent_gfeWrapper__11vs3"};